import * as React from 'react';
import equal from 'fast-deep-equal/react';
import styles from './PremiumAccountLink.scss';
import { t } from '~/utils/localization';
import className from 'classnames';
import { DivTooltip } from '@wg/wows-react-uikit';
import AccountPremiumTooltip from '~/components/Tooltip/AccountPremiumTooltip';
import dwhExport from '~/api/dwhExport';
import { CATEGORIES, DWH_EVENTS } from '~/const';
import { openCategoryByName } from '~/utils/category';
import { playButtonClickSound } from '~/api/WoWsClient';
import { RootState, useAppSelector } from '~/Store';
import { getPremiumDurationText } from '~/utils/time';
import LabelDecorator, { LABEL_TYPE } from '~/decorators/LabelDecorator/LabelDecorator';
import { isLabelNewShownForCategory } from '~/utils/labels';
import LabelContainer from '~/containers/LabelContainer/LabelContainer';

const stateSelector = (state: RootState) => {
    return {
        accountId: state.account.id,
        balance: state.account.balance,
        categories: state.app.categories,
        viewedLabels: state.account.viewedLabels,
    };
};

const PremiumAccountLink = () => {
    const state = useAppSelector(stateSelector, equal);
    const balance = state.balance;

    const goToWoWSPremium = () => {
        playButtonClickSound();

        dwhExport.send(DWH_EVENTS.OPEN_WOWS_PREM_FROM_TOP_MENU);
        openCategoryByName(CATEGORIES.PURCHASE_WOWS_PREMIUM);
    };

    const premiumCategory = state.categories?.[CATEGORIES.PURCHASE_WOWS_PREMIUM];
    const isPremAccountCategoryEnabled = !!premiumCategory;

    const renderUserContent = () => {
        if (!state.accountId) {
            return null;
        }

        const isLabelNewAllowed = isLabelNewShownForCategory(premiumCategory?.name);
        const warshipsAccountPremium = balance?.['warships_account_premium']?.value || 0;
        const generalAccountPremium = balance?.['general_account_premium']?.value || 0;
        const hasPremium = warshipsAccountPremium > 0 || generalAccountPremium > 0;
        const accountPremiumSeconds = warshipsAccountPremium || generalAccountPremium;

        const accountPremiumText = hasPremium ? getPremiumDurationText(accountPremiumSeconds) : t('Купить Премиум аккаунт');

        const accountPremiumClassName = className(styles.accountPremiumWrapper, {
            [styles.withIcon]: hasPremium,
            [styles.generalAccountPremium]: !!generalAccountPremium && !warshipsAccountPremium,
        });

        return (
            <React.Fragment>
                {isPremAccountCategoryEnabled && (
                    <DivTooltip
                        tooltipBody={
                            <AccountPremiumTooltip warshipsPremiumSeconds={warshipsAccountPremium} generalPremiumSeconds={generalAccountPremium} text={t('Купить дни Корабельного премиум аккаунта')} />
                        }
                    >
                        <LabelDecorator id={premiumCategory.labelNewActiveTill ? premiumCategory.name : null} isEnabled={isLabelNewAllowed} type={LABEL_TYPE.category}>
                            <div className={accountPremiumClassName} onClick={goToWoWSPremium} data-has-premium={hasPremium}>
                                <span className={styles.accountPremiumText}>{accountPremiumText}</span>
                                <LabelContainer className={styles.labelNew} isVisible={isLabelNewAllowed} />
                            </div>
                        </LabelDecorator>
                    </DivTooltip>
                )}
            </React.Fragment>
        );
    };

    return <>{renderUserContent()}</>;
};

export default PremiumAccountLink;
